<template>
    <transition name="layout-fade">
        <v-layout v-if="msg" wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактирование сообщения</v-toolbar-title>

                <v-spacer/>

                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading || msg.username !== undefined && msg.username.length > 0" @click="sendForm(false)">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="msg_name"
                        v-model="msg.name"
                        v-validate="'required|max:50'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        single-line
                        solo
                        text
                        required/>
                </v-flex>

                <v-layout>
                    <v-flex xs6 mb-6>
                        <v-layout mb-4>
                            <v-flex xs12>
                                <v-subheader class="pa-0">Укажите тип</v-subheader>

                                <div class="mb-1">
                                    <v-select solo v-model="select" :items="items"/>
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs8>
                                <template v-if="select === 'img'">
                                    <upload-img :image-width="1024" :image-height="1024" v-model="msg.image">
                                        <template slot="activator">
                                            <v-avatar size="200px" v-ripple tile v-if="msg.image.imageURL">
                                                <img :src="msg.image.imageURL" alt="Изображение для категории"/>
                                            </v-avatar>
                                            <v-avatar size="200px" v-ripple tile
                                                      v-else-if="!msg.image.imageURL && msg.image">
                                                <v-img :src="rootURL + msg.image" aspect-ratio="1">
                                                    <v-layout
                                                        slot="placeholder"
                                                        fill-height
                                                        align-center
                                                        justify-center
                                                        ma-0>
                                                        <v-progress-circular indeterminate
                                                                             color="grey"></v-progress-circular>
                                                    </v-layout>
                                                </v-img>
                                            </v-avatar>
                                            <v-avatar size="200px" v-ripple class="grey lighten-3" tile v-else>
                                                <img src="/static/img/media/image_blank.svg"
                                                     alt="Нажмите чтобы добавить картинку для категории"/>
                                            </v-avatar>
                                        </template>
                                    </upload-img>
                                </template>

                                <template v-else-if="select === 'video'">
                                    <v-subheader class="pa-0">Видео (до 2мб)
                                    </v-subheader>

                                    <div class="mb-4">
                                        <v-avatar @click="clickInputVideo" v-if="!msg.video.url" size="200px" v-ripple
                                                  class="grey lighten-3" tile>
                                            <img src="/static/img/media/image_blank.svg"
                                                 alt="Нажмите чтобы добавить картинку для сообщения"/>
                                        </v-avatar>

                                        <video height="200" width="200" ref="video" v-show="msg.video.url" controls
                                               :src="msg.video.url"></video>
                                    </div>

                                    <v-file-input ref="input" class="file-input-video" style="max-width: 200px"
                                                  v-model="video" prepend-icon="mdi-camera" accept=".mp4"
                                                  @change="changeVideo"
                                                  @click:clear="clearVideo"
                                                  label="Выберите видео" outlined dense/>
                                </template>
                            </v-flex>

                            <v-flex xs4>
                                <v-subheader class="pa-0">Отправить сразу</v-subheader>
                                <v-checkbox disabled :label="msg.send ? 'Да' : 'Нет'" v-model="msg.send" class="mt-0"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex offset-1 xs6>
                        <v-subheader class="pa-0">Описание</v-subheader>
                        <v-textarea
                            ref="msg_text"
                            v-model="msg.text"
                            v-validate="'required|max:255'"
                            :error-messages="errors.collect('text')"
                            data-vv-name="text"
                            single-line
                            solo
                            text
                            required
                            counter="255"/>
                    </v-flex>
                </v-layout>

                <v-layout row class="mb-4">
                    <v-toolbar text>
                        <v-toolbar-title>Отправить тестовое сообщение</v-toolbar-title>
                    </v-toolbar>
                </v-layout>

                <v-flex xs6>
                    <v-subheader class="pa-0">Username телеграм пользователя</v-subheader>
                    <v-text-field
                        ref="msg_username"
                        v-model="msg.username"
                        v-validate="'max:50'"
                        data-vv-name="name"
                        :error-messages="errors.collect('username')"
                        single-line
                        solo
                        text/>
                </v-flex>

                <v-flex class="mb-6" xs12>
                    <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading"
                           @click="sendForm(true)">
                        Отправить
                        <span slot="loader" class="custom-loader">
                                <v-icon light>cached</v-icon>
                            </span>
                    </v-btn>
                </v-flex>

                <p v-if="msg.send_count">Общее количество отправок: {{ msg.send_count }}</p>
                <p v-if="msg.customers_count">Общее количество пользователей: {{ msg.customers_count }}</p>
                <p v-if="msg.received_customers_count" style="color: red">Количество пользователей не получивших
                    уведомления: {{ msg.customers_count - msg.received_customers_count }}</p>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
import config from '../../../config'
import UploadImg from '../../../components/Media/Upload'
import Telegram from '../../../api/telegram'

export default {
    components: { UploadImg },
    $_veeValidate: {
        validator: 'new'
    },
    name: 'editTgMessage',
    data: () => ({
        loading: false,
        loader: false,
        msg: {
            name: '',
            image: '',
            username: '',
            video: {
                url: '',
                base64: '',
            },
            text: '',
            send: true,
            testSend: false,
        },
        select: '',
        video: null,
        rootURL: '',
        dictionary: {
            custom: {
                name: {
                    required: 'Введите тайтл',
                    max: 'Превышено максимальное количество символов в названии'
                },
                text: {
                    required: 'Описание не заполнено',
                    max: 'Превышено максимальное количество символов в описании'
                }
            }
        },
        items: [
            {
                text: 'Изображение',
                value: 'img',
            },

            {
                text: 'Видео',
                value: 'video',
            },
        ],
    }),
    created () {
        this.rootURL = config.rootPath
        this.$validator.localize('ru', this.dictionary)
    },
    mounted () {
        this.getTgMsg(this.$route.params.tgMessageId)
    },
    methods: {
        getTgMsg (msgId) {
            Telegram
                .getById(msgId)
                .then(response => {
                    let msg = response.data.data
                    msg.video = {
                        url: msg.video ?? '',
                        base64: '',
                    }
                    msg.image = msg.image ?? ''
                    msg.send = true

                    this.msg = msg
                    if (msg) {
                        this.select = msg.image ? 'img' : 'video'
                        this.selectVideo()
                    }
                })
                .catch(error => {
                    this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                    this.$router.push({ name: 'tgMessageRoot' })
                })
                .finally(() => this.loader = false)

        },

        sendForm (isTest = false) {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) return

                    this.loading = true

                    if (this.select === 'img') {
                        this.msg.video = ''
                    } else {
                        this.msg.image = ''
                    }

                    this.msg.testSend = isTest

                    Telegram
                        .edit(this.msg)
                        .then(response => {
                            let msg = response.data.data
                            this.$store.commit('updateTgMessage', msg)
                            let text = isTest ? 'Отлично! Тестовое сообщение отредактировано и сохранено' : 'Успех! Сообщение отредактировано и сохранено'

                            this.msg.customers_count = msg.customers_count
                            this.msg.received_customers_count = msg.received_customers_count
                            this.msg.send_count = msg.send_count

                            this.$store.commit('showSnackbar', {
                                text: text,
                                color: 'success'
                            })
                        })
                        .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                        .finally(() => this.loading = false)
                })
                .catch(error => new Error(error))
        },

        toBase64 (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        async changeVideo (file) {
            if (!file) return

            if (file.size > 2097152) {
                this.$store.commit('showSnackbar', { text: 'Размер файла превышает 2 мб.' })
                this.clearVideo()

                return
            }

            this.msg.video = {
                base64: await this.toBase64(file),
                url: URL.createObjectURL(file),
            }
        },

        clearVideo () {
            this.msg.video = ''
            this.video = ''
        },

        selectVideo () {
            if (this.msg.video.url) {
                this.msg.video = {
                    url: this.rootURL + this.msg.video.url
                }
            }
        },

        clickInputVideo () {
            let input = this.$refs.input
            if (input) {
                input.$refs.input.click()
            }
        }
    },
    beforeRouteLeave (to, from, next) {
        next()
    },
    beforeRouteUpdate (to, from, next) {
        this.msg = this.getTgMsg(to.params.tgMessageId)
        next()
    },
}
</script>
